import { createAsyncThunk } from '@reduxjs/toolkit'
import { getDiceGameBetHistory, diceGamePlaceBet } from 'games/Dice/services/diceGame.service'
import { setDiceBetHistory, setDiceLossCount, setDiceWinsCount, setDiceProfit, setDiceWagered } from 'games/Dice/slices-thunks/diceGame.slice'
import {
  setDiceStrategyResultArray,
  setLoseStreakCount,
  setStrategyBetCount,
  setStrategyLoseCount,
  setStrategyWinCount,
  setWinStreakCount
} from 'games/Dice/slices-thunks/diceStrategy.slice'
import { BET_RESULT } from 'utils/constants/index'
import { openErrorToaster } from 'utils/common-services/toaster.service'
import { generateClientSeed, getPrecision } from 'utils/common-functions/index'
import { setNewClientSeed, setServerSeedHash } from 'redux-store/redux/slices/gameSettings.slice'
import { dequeueCreditWalletWaitQueue, updateDemoWalletBalance } from 'redux-store/redux/slices/auth.slice'
import { diceGameDemoPlaceBet } from '../GameTheme/DiceGame/diceGame.helper'

export const getDiceGameBetRecord = createAsyncThunk(
  'diceGame/get-bet-history', async ({ limit, page }, thunkApi) => {
    try {
      const res = await getDiceGameBetHistory({ limit, page })
      return res
    } catch (error) {
      openErrorToaster(error[0].description)
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)

export const diceGamePlacedBet = createAsyncThunk(
  'diceGame/place-bet', async ({ payload, isDemoGame, demoWallet, handleCancelAutoBet }, thunkApi) => {
    try {
      let res
      if (!isDemoGame) {
        res = await diceGamePlaceBet({ data: payload })
      } else {
        res = diceGameDemoPlaceBet(payload)
      }
      const { diceBetHistory } = thunkApi?.getState()?.diceGame
      const { isStrategyMode, strategyResultArray } = thunkApi?.getState()?.diceStrategy

      if (res?.nextServerSeedHash) {
        const newClientSeed = generateClientSeed()
        thunkApi.dispatch(setNewClientSeed(newClientSeed))
        thunkApi.dispatch(setServerSeedHash(res.nextServerSeedHash))
      }

      let newBetHistory = {}
      let rows = [{ ...res }]
      if (diceBetHistory) {
        rows = [...rows, ...diceBetHistory?.rows]
      }
      newBetHistory = { count: diceBetHistory?.count ? diceBetHistory?.count + 1 : 1, rows }
      thunkApi.dispatch(setDiceBetHistory(newBetHistory))

      if (res?.result) {
        thunkApi.dispatch(setDiceStrategyResultArray([...strategyResultArray, res?.result]))
      }
      if (isStrategyMode) {
        if (res?.result === BET_RESULT.WON) {
          thunkApi.dispatch(setWinStreakCount())
          thunkApi.dispatch(setLoseStreakCount({ reset: 0 }))
          thunkApi.dispatch(setStrategyWinCount())
          thunkApi.dispatch(setStrategyBetCount())
        } else {
          thunkApi.dispatch(setLoseStreakCount())
          thunkApi.dispatch(setWinStreakCount({ reset: 0 }))
          thunkApi.dispatch(setStrategyLoseCount())
          thunkApi.dispatch(setStrategyBetCount())
        }
      }

      if (res?.result === BET_RESULT.WON) {
        thunkApi.dispatch(setDiceWinsCount())
        thunkApi.dispatch(setDiceProfit(res))
        thunkApi.dispatch(setDiceWagered(res?.betAmount))
        if (isDemoGame) {
          thunkApi.dispatch(updateDemoWalletBalance(getPrecision(demoWallet?.balance + res?.winningAmount, 2)))
        }
      } else {
        thunkApi.dispatch(setDiceLossCount())
        thunkApi.dispatch(setDiceProfit(res))
        thunkApi.dispatch(setDiceWagered(res?.betAmount))
      }
      thunkApi.dispatch(dequeueCreditWalletWaitQueue())

      return res
    } catch (error) {
      console.log(error)
      openErrorToaster(error[0].description)
      handleCancelAutoBet()
      return thunkApi.rejectWithValue(error[0]?.description)
    }
  }
)
